import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from "@azure/msal-browser";
import { FailedComponent } from './components/failed/failed.component'
import { AuthGuard } from './shared/services/auth.guard';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./main/main.module').then(m => m.MainModule),
        canActivate: [
          MsalGuard,
          AuthGuard
        ]
      },
    
    // {
    //     path: '**',
    //     redirectTo: '',
    //     pathMatch: 'full'
    // },
    {
        path:'login-failed',
        component:FailedComponent
      }

];
@NgModule({
    imports: [
        RouterModule.forRoot((routes), {
            useHash: true,
            // Don't perform initial navigation in iframes or popups
            initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
        })],
    exports: [RouterModule]
})
export class AppRoutingModule { }

